<!DOCTYPE HTML>
<template>
<div class="footer">
  <div class="brand">
    <div class="logo" />
    BlueTeam
  </div>
  <div class="col text-center"
       v-for="col in [mainNav, midNav, subNav, otherNav]"
       :key="col.id">
    <template v-for="item in col">
      <router-link v-if="item.link"
                   :key="item.id"
                   :to="item.link"
                   class="text-center">
        {{item.label}}
      </router-link>

        <v-btn v-else-if="item.icon"
              :key="item.icon"
              :to="item.link"
              class="mx-4 white--text"
              icon>
            <v-icon size="24px">{{ item.icon }}</v-icon>

        </v-btn>

      <span v-else
            :key="item.id">{{item.label}}</span>
    </template>
  </div>
</div>

</template>




<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  },
  data() {
    return {
      mainNav: [
        { label: 'Home', link: '/' },
        { label: 'About', link: '/about' },
        //{ icon: 'fab fa-twitter', label: 'twitter', link:'/twitter'},
        { label: "", link: '/twitter'},
      ],
      midNav: [
        { label: 'Security Stuff', link: '/stuff'},
        { label: 'Contact Us', link: '/contact'},
        { label: "", link: '/linkedin' },
      ],
      subNav: [
        { label: 'Admins', link: '/admin' },
        { label: 'Sign in', link: '/signin' },
        { label: "", link: '/github' },
      ],
      otherNav: [
        { label: '©2020 BlueTeam' },

      ]
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/styles/overrides.scss";
@import "@/styles/global.scss";

.footer {
    margin: 0 auto;
    max-width: 1200px;
    padding: 10rem 3rem;

    display: grid;
    grid-auto-flow: column;
    align-content: flex-start;
    align-items: flex-start;
    color: $primary;

    .brand {
        display: grid;
        grid-auto-flow: column;
        justify-content: flex-start;
        align-items: center;
        grid-gap: .5rem;

        .logo {
            height: 2rem;
            width: 2rem;
            background-image: url("../assets/BlueTeamLogo.png");
            background-size: contain;
        }
    }

    .col {
        display: grid;
        grid-row-gap: 1rem;
        justify-content: flex-start;


        * {
            font-family: 'Roboto','fa-brands';

            font-size: 0.8rem;
        }

        span {
            opacity: 0.5;
        }

    }
}
</style>

<codepen-resources lang="json">
  {
  "js": ["https://use.fontawesome.com/releases/v5.0.6/js/all.js"]
  }
</codepen-resources>
